import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import clsx from 'clsx';

import { useStyles } from './style';
import { MoreButton } from '../../..';

interface DownloadButtonProps {
	downloadData?: object;
}

const DownloadButton = (props: DownloadButtonProps) => {
	const { downloadData } = props;

	const classes = useStyles();

	return (
		<div className={clsx(classes.root)}>
			<MoreButton
				disabled={downloadData.disabled}
				menuItems={downloadData.action()}
				startIcon={<InsertDriveFileOutlinedIcon />}
				text={downloadData.text}
			/>
		</div>
	);
};

export default DownloadButton;
